import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '../UI/dialog';
import { Button } from '../UI/button';
import { Label } from '../UI/label';
import { ArrowLeft, X, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { checkUserRights } from '../../Utils/Utilities';

const ImpDialog = ({
  open,
  onOpenChange,
}) => {
  const navigate = useNavigate();
  const userRights = checkUserRights();

  const options = [
    ...(userRights?.addConns
      ? [
        {
          key: 'contacts',
          label: 'Contacts',
          onClick: () => {
            onOpenChange(false);
            navigate('/connections?openImport=true');
          },
        },
      ]
      : []),
    ...(userRights?.addThr
      ? [
          {
            key: 'inquiries',
            label: 'Inquiries',
            onClick: () => {
              onOpenChange(false);
              navigate('/threads?openImport=true');
            },
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (open && options.length === 1) {
      options[0].onClick();
    }
  }, [open]);

  if (options.length === 1) {
    return null;
  }

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        className="sm:max-w-md w-full"
      >
        <DialogHeader className="gap-0 px-3 sm:px-4 md:px-4">
          <div className="sm:hidden flex items-center justify-between w-full h-8">
            <div className="flex items-center gap-2 flex-1 min-w-0">
              <DialogClose
                tabIndex={-1}
                className="p-0 w-auto h-auto flex-shrink-0 flex justify-center"
                onClick={handleCancel}
              >
                <ArrowLeft className="h-6 w-6" />
                <span className="sr-only">Back</span>
              </DialogClose>
              <DialogTitle className="text-lg font-medium">
                <div className="truncate">
                  Import
                </div>
              </DialogTitle>
            </div>
          </div>

          {/* Desktop: Title */}
          <DialogTitle className="hidden sm:block text-lg md:text-xl">
            Import
          </DialogTitle>
          <div className="hidden sm:flex items-center gap-2">
            <DialogClose
              className="flex-shrink-0"
              tabIndex={-1}
              onClick={handleCancel}
            >
              <X className="h-5 w-5" />
              <span className="sr-only">Close</span>
            </DialogClose>
          </div>
        </DialogHeader>

        <div className="px-4 flex-1 overflow-y-auto max-h-[70vh]">
          <div className="space-y-4">
            <div>
              <Label className="font-medium mb-3 block">What do you want to import?</Label>

              <div className={userRights?.addThr ? 'grid grid-cols-2 gap-3' : 'flex justify-start'}>
                {options.map((option) => (
                  <div
                    key={option.key}
                    onClick={option.onClick}
                    className="flex items-center justify-center px-4 py-3 rounded-md border transition-all duration-200 cursor-pointer bg-white border-gray-300 hover:border-sahi-primary-color hover:bg-gray-50"
                  >
                    <span>{option.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex gap-2 py-2 my-2">
            <Button variant="secondary" onClick={handleCancel}>
              <X className="h-4 w-4" />
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImpDialog;